// Product analytics from the browser, for the steps the server cannot see
// (the list is CLIENT_EVENTS in server/analytics.js; anything else is
// dropped there). Events go to our own server in small batches, and the same
// event goes to GA4 when gtag is loaded. Nothing is stored on the device: the
// session id lives in memory for one page load.
import { API_BASE } from "./apiBase";
import { randomId } from "./utils/randomId.ts";

const sessionId = randomId(16);
// Read at import, before the Vipps return strips the query
const landing = new URLSearchParams(window.location.search);
const queue = [];
let flushTimer = null;

function flush() {
  clearTimeout(flushTimer);
  flushTimer = null;
  if (queue.length === 0) return;
  const body = JSON.stringify({ sessionId, events: queue.splice(0) });
  const url = `${API_BASE}/api/e`;
  // text/plain keeps it a simple request, so no CORS preflight
  const blob = new Blob([body], { type: "text/plain" });
  if (navigator.sendBeacon && navigator.sendBeacon(url, blob)) return;
  fetch(url, { method: "POST", body: blob, keepalive: true }).catch(() => {});
}

window.addEventListener("pagehide", flush);

/** Record an event; `room` is the room name when it happened in one. */
export function track(event, props = {}, room = null) {
  queue.push({ event, props, room, at: new Date().toISOString() });
  if (window.gtag) {
    const gaProps = Object.fromEntries(
      Object.entries(props).filter(([, v]) => v !== null && v !== undefined),
    );
    window.gtag("event", event, gaProps);
  }
  if (queue.length >= 10) flush();
  else if (!flushTimer) flushTimer = setTimeout(flush, 2000);
}

let opened = false;

/** Once per page load: where the visit came from and what it runs on. */
export function trackAppOpened(language) {
  if (opened) return;
  opened = true;
  let referrerHost = null;
  try {
    referrerHost = document.referrer ? new URL(document.referrer).host : null;
  } catch {}
  track("app_opened", {
    referrer_host: referrerHost,
    utm_source: landing.get("utm_source"),
    utm_medium: landing.get("utm_medium"),
    utm_campaign: landing.get("utm_campaign"),
    language,
    display_mode: window.matchMedia("(display-mode: standalone)").matches
      ? "standalone"
      : "browser",
    viewport_width: window.innerWidth,
  });
}
